import PayPaymentPlanError from './PayPaymentPlanError';
class InsufficientFundsToPay extends PayPaymentPlanError {
    constructor(options) {
        super('The resource funds is insufficient', options);
    }
}
export default InsufficientFundsToPay;
